<template>
  <div>
    <hero-bar :has-right-visible="true">
<!--      <div slot="title">{{ horse.name }}</div>-->
      <div slot="title">{{ horseName }}</div>
      <div slot="sub-title">Ficha del Caballo</div>
      <div slot="right">
        <!-- <div class="buttons is-right">
        </div> -->
        <horse-indicators  v-if="horse" :rider="rider" :horse="horse" :total-score="totalScore" @lesson-clicked="showLesson" @rider-clicked="goToRider"></horse-indicators>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-3">
          <card-component title="Ficha del Caballo" class="has-table has-mobile-sort-spaced">
            <div slot="headerRight" class="card-header-icon">
              <div class="buttons">
                <b-button @click="isEditModalActive = true" type="is-success">Editar</b-button>
              </div>
            </div>
            <horse-information class="card-content-padding" slot="content" :horse="horse" v-if="horse && !isLoading"></horse-information>
            <div style="min-height: 200px;" v-else-if="isLoading" slot="content">
              <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
            </div>
          </card-component>
        </div>
        <div class="column">
          <card-component title="Información Detallada" :subtitle="subtitle" class="has-table has-mobile-sort-spaced">
            <div slot="content">
              <b-tabs v-model="activeTab">
                <b-tab-item label="Historial Evaluaciones">
                  <horse-scores-table  @number-result-changed="numberScores = $event" :horse-id="horseId" @total-score-calculated="totalScoreChange"></horse-scores-table>
                </b-tab-item>
                <b-tab-item label="Historial Asignaciones">
                  <horse-history-assignments  @number-result-changed="numberAssignments = $event" :horse-id="horseId"></horse-history-assignments>
                </b-tab-item>
                <b-tab-item label="Historial Lecciones">
                  <horse-history-lessons  @number-result-changed="numberLessons = $event" :horse-id="horseId"></horse-history-lessons>
                </b-tab-item>
              </b-tabs>
            </div>
          </card-component>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <card-component title="Rendimiento por Lección" class="has-table has-mobile-sort-spaced">
            <horse-performance-chart class="card-content-padding" :horse-id="horseId" slot="content"></horse-performance-chart>
          </card-component>
        </div>
      </div>
      <lesson-pdf-Modal :lesson-id="lessonId" :text="lessonName" :active.sync="showLessonModal"/>
    </section>
    <horse-form :active.sync="isEditModalActive" :horse-id="horseId" @saved="getHorse"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import HorseService from '@/services/HorseService'
import HorseScoresTable from './components/HorseScoresTable'
import HorseInformation from './components/HorseInformation'
import HorseIndicators from './components/HorseIndicators'
import HorseHistoryAssignments from './components/HorseHistoryAssignments'
import HorseHistoryLessons from './components/HorseHistoryLessons'
import HorsePerformanceChart from './components/HorsePerformanceChart'
import LessonPdfModal from '@/components/LessonPDFModal'
import HorseForm from './components/HorseForm'

export default {
  components: {
    HeroBar,
    CardComponent,
    HorseScoresTable,
    HorseInformation,
    HorseIndicators,
    HorseHistoryAssignments,
    HorseHistoryLessons,
    HorsePerformanceChart,
    LessonPdfModal,
    HorseForm
  },
  data () {
    return {
      activeTab: 0,
      horseId: this.$route.params.id,
      horse: null,
      isLoading: false,
      totalScore: 0,
      numberScores: 0,
      numberAssignments: 0,
      numberLessons: 0,
      showLessonModal: false,
      lessonId: null,
      lessonName: null,
      isEditModalActive: false
    }
  },
  computed: {
    horseName () {
      return this.horse ? this.horse.name : 'Caballo'
    },
    rider () {
      return this.horse ? this.horse.rider : null
    },
    subtitle () {
      let subtitle
      let text
      if (this.activeTab === 0) {
        text = this.numberScores === 1 ? 'evaluación realizada' : 'evaluaciones realizadas'
        subtitle = `${this.numberScores} ${text}`
      } else if (this.activeTab === 1) {
        text = this.numberAssignments === 1 ? 'asignación a jinete' : 'asignaciones a jinete'
        subtitle = `${this.numberAssignments} ${text}`
      } else if (this.activeTab === 2) {
        text = this.numberLessons === 1 ? 'lección historica' : 'lecciones historicas'
        subtitle = `${this.numberLessons} ${text}`
      }
      return subtitle
    }
  },
  created () {
    this.getHorse()
  },
  methods: {
    async getHorse () {
      this.isLoading = true
      let params = {
        'include[0]': 'rider',
        'include[1]': 'father',
        'include[2]': 'mother',
        'include[3]': 'lesson'
      }
      let response = await HorseService.getHorse(this.horseId, params)
      this.horse = response.data.data
      this.isLoading = false
    },
    totalScoreChange (value) {
      this.totalScore = value
    },
    goToRider (rider) {
      if (rider) {
        this.router.push({ name: 'riders.detail', params: { id: rider.id } })
      }
    },
    showLesson (lesson) {
      this.lessonName = lesson.name
      this.lessonId = lesson.id
      if (lesson) {
        this.showLessonModal = true
      }
    }
  },
  watch: {
    '$route.params.id' () {
      this.horseId = this.$route.params.id
    },
    horseId () {
      this.getHorse()
    }
  }
}
</script>
